import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import missionImg from './images/our-mission.png';
import visionImg from './images/our-vision.png';

const useStyles = makeStyles((theme) => ({
  sectionWrapper: {
    width: '100%',
    backgroundColor: '#141414',
    padding: '50px 0 50px 0',
    marginBottom: '60px',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 0 32px 0',
      marginBottom: '36px',
    }
  },
  sectionContainer: {
    maxWidth: '1314px',
    margin: '0 auto',
    padding: '0 24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      gap: '36px',
    }
  },
  rowBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '30px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '20px',
    }
  },
  rowBlockReversed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '30px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      gap: '24px',
    }
  },
  imageWrapper: {
    flex: 1,
    maxWidth: '642px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    }
  },
  blockImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '400px',
    objectFit: 'cover',
    borderRadius: '20px',
    display: 'block',
    boxShadow: '0 12px 36px rgba(0, 0, 0, 0.45)',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '16px',
    }
  },
  textWrapper: {
    flex: 1,
    maxWidth: '560px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    }
  },
  blockTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '100%',
    color: '#ffffff',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      marginBottom: '10px',
    }
  },
  blockParagraph: {
    fontFamily: '"Roboto", sans-serif',
    color: '#A3A3A3',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '27px',
    marginBottom: '18px',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      fontWeight: 200,
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '0px',
    }
  }
}));

export const AboutUsMissionVisionSection = () => {
  const classes = useStyles();

  return (
    <Box className={classes.sectionWrapper}>
      <Box className={classes.sectionContainer}>
        {/* Our Mission: Image Left, Text Right */}
        <Box className={classes.rowBlock}>
          <Box className={classes.imageWrapper}>
            <img
              src={missionImg}
              alt="Our Mission"
              className={classes.blockImage}
            />
          </Box>
          <Box className={classes.textWrapper}>
            <Typography className={classes.blockTitle}>
              Our Mission
            </Typography>
            <Typography className={classes.blockParagraph}>
              To redefine the creator economy by building the most trusted, exclusive, and creator-first platform for premium monetization, curated discovery, and high-value member connections.
            </Typography>
            <Typography className={classes.blockParagraph}>
              Every decision we make is guided by one goal: creating an environment where creators can grow sustainable businesses while members enjoy authentic, premium experiences.
            </Typography>
          </Box>
        </Box>

        {/* Our Vision: Text Left, Image Right */}
        <Box className={classes.rowBlockReversed}>
          <Box className={classes.textWrapper}>
            <Typography className={classes.blockTitle}>
              Our Vision
            </Typography>
            <Typography className={classes.blockParagraph}>
              To become the leading premium creator platform for high-value creator-member relationships.
            </Typography>
            <Typography className={classes.blockParagraph}>
              Rather than building for generic scale, we're focused on building the most trusted, exclusive, and monetization-rich experience in our category - where creators can thrive and members can discover exceptional experiences.
            </Typography>
          </Box>
          <Box className={classes.imageWrapper}>
            <img
              src={visionImg}
              alt="Our Vision"
              className={classes.blockImage}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsMissionVisionSection;
